<i18n lang="yaml">
  en:
    title: Compatibilty configurator
  fr:
    title: Configurateur compatibilité
</i18n>

<template>
  <h1>{{ $t('title') }}</h1>
</template>

<script>
export default {
  layout: 'configurator',
  nuxtI18n: {
    paths: {
      en: '/compatibility/',
      fr: '/compatibilite/',
    },
  },
  created() {
    this.$router.push(
      this.localePath({
        name: 'compatibility-step',
        params: {
          step: '1',
        },
      })
    );
  },
};
</script>
